import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '@/components/ui/table';
import { toast } from 'sonner';
import { PLAN_COLORS } from './AdminDashboard';

export const AdminSubscriptions = ({ api, users, setUsers, stats, fetchStats }) => {
  const handlePlanChange = async (userId, userName, newPlan) => {
    try {
      await api.put(`/admin/users/${userId}`, { plan: newPlan });
      setUsers(prev => prev.map(u => u.id === userId ? { ...u, plan: newPlan } : u));
      toast.success(`Plan de ${userName} mis \u00e0 jour vers ${newPlan}`);
      fetchStats();
    } catch {
      toast.error("Erreur lors de la mise \u00e0 jour");
    }
  };

  return (
    <div>
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        {[
          { plan: 'STARTER', price: '19', border: 'border-zinc-300 dark:border-zinc-700' },
          { plan: 'PRO', price: '39', border: 'border-blue-400' },
          { plan: 'PREMIUM', price: '59', border: 'border-amber-400' },
        ].map(p => (
          <Card key={p.plan} className={`border-2 ${p.border}`}>
            <CardHeader className="pb-2"><Badge className={`w-fit ${PLAN_COLORS[p.plan]}`}>{p.plan}</Badge></CardHeader>
            <CardContent>
              <p className="text-3xl font-bold font-['Manrope']">{p.price}&euro;<span className="text-sm font-normal text-muted-foreground">/mois</span></p>
              <p className="text-sm text-muted-foreground mt-1">{stats?.usersByPlan?.[p.plan] || 0} utilisateur{(stats?.usersByPlan?.[p.plan] || 0) !== 1 ? 's' : ''}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader><CardTitle>{"G\u00e9rer les abonnements"}</CardTitle></CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Utilisateur</TableHead>
                <TableHead>Plan actuel</TableHead>
                <TableHead>Changer le plan</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {users.map((u) => (
                <TableRow key={u.id}>
                  <TableCell>
                    <p className="font-medium text-sm">{u.name}</p>
                    <p className="text-xs text-muted-foreground">{u.email}</p>
                  </TableCell>
                  <TableCell><Badge className={PLAN_COLORS[u.plan]}>{u.plan}</Badge></TableCell>
                  <TableCell>
                    <Select value={u.plan} onValueChange={(v) => handlePlanChange(u.id, u.name, v)}>
                      <SelectTrigger className="w-36" data-testid={`sub-plan-${u.id}`}><SelectValue /></SelectTrigger>
                      <SelectContent>
                        <SelectItem value="STARTER">STARTER</SelectItem>
                        <SelectItem value="PRO">PRO</SelectItem>
                        <SelectItem value="PREMIUM">PREMIUM</SelectItem>
                      </SelectContent>
                    </Select>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminSubscriptions;
